module.exports = __webpack_public_path__ + "static/steigerung-c7546d24f14a36d8aa1589385037fdb4.png";